import { Payment, PaymentProviders } from '../../state/payment/payment.types';

export const getPayments = (
  providers?: PaymentProviders['deposits'],
  isApplePayAvailable?: boolean,
  payments: Partial<Payment>[] = Object.values(Payment),
) =>
  providers
    ? Object.values(payments).filter((payment) => {
        // Filter out Apple Pay if it's not available
        if (payment === Payment.ApplePay) {
          return isApplePayAvailable && providers.includes('WorldpayApplePay');
        }

        return payment === Payment.Interac
          ? providers.includes('Gigadat')
          : providers.includes('Nuvei');
      })
    : [];
